import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DidimLogo } from './didimLogo';

export const ContentsIconDefault = ({
    size = 60,
    color,
    ...props
}) => {
    const theme = useTheme();

    const backgroundColor = color ? color : theme.palette.background.sub;



    return (
        <Box
            sx={{
                display: 'flex',
                width: size,
                height: size,
                padding: '0 5.5px 0 4.5px',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
                aspectRatio: '1/1',
                borderRadius: size,
                border: '1px solid ' + theme.palette.figma.white[30],
                background: backgroundColor,
                ...props.sx
            }}
            {...props}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="7" viewBox="0 0 50 7" fill="none">
                <g opacity="0.4" clipPath="url(#clip0_792_18194)">
                    <path d="M49.3161 0.266901H49.186V0.199751H49.5194V0.266901H49.3893V0.611153H49.3161V0.266901ZM49.596 0.199751H49.6725L49.7976 0.394402L49.9226 0.199751H50V0.611153H49.9286V0.316202L49.7984 0.510003H49.7959L49.6674 0.317052V0.610303H49.596V0.199751ZM10.421 0H2.43987C1.9899 0 1.62415 0.365502 1.62415 0.816004C1.62415 1.26651 1.9899 1.63116 2.43987 1.63116H10.421C11.1848 1.63116 11.8066 2.25251 11.8066 3.01582C11.8066 3.77912 11.1848 4.40047 10.421 4.40047H3.25644V3.01582C3.25644 2.56531 2.89068 2.20066 2.44072 2.20066C1.99075 2.20066 1.62415 2.56531 1.62415 3.01582V5.21648C1.62415 5.66698 1.9899 6.03163 2.43987 6.03163H10.421C12.0848 6.03163 13.4389 4.67842 13.4389 3.01582C13.4389 1.35321 12.0856 0 10.421 0ZM27.8812 0H19.9C19.4492 0 19.0843 0.365502 19.0843 0.815154C19.0843 1.26481 19.4501 1.63031 19.9 1.63031H27.8812C28.645 1.63031 29.2668 2.25166 29.2668 3.01497C29.2668 3.77827 28.645 4.39962 27.8812 4.39962H20.7166V3.01497C20.7166 2.56446 20.3508 2.19981 19.9009 2.19981C19.4509 2.19981 19.0852 2.56531 19.0852 3.01497V5.21563C19.0852 5.66613 19.4509 6.03078 19.9009 6.03078H27.882C29.5466 6.03078 30.8999 4.67758 30.8999 3.01497C30.8999 1.35236 29.5449 0 27.8812 0ZM16.1693 0C15.7185 0 15.3536 0.365502 15.3536 0.815154V5.21563C15.3536 5.66613 15.7194 6.03078 16.1693 6.03078C16.6193 6.03078 16.985 5.66528 16.985 5.21563V0.816004C16.985 0.365502 16.6201 0 16.1693 0ZM33.6286 0C33.1778 0 32.8129 0.365502 32.8129 0.815154V5.21563C32.8129 5.66613 33.1787 6.03078 33.6286 6.03078C34.0786 6.03078 34.4443 5.66528 34.4443 5.21563V0.816004C34.4452 0.365502 34.0794 0 33.6286 0ZM47.9909 0.134301C47.7613 -0.0161501 47.4712 -0.0416502 47.2186 0.0671504L42.451 2.12756L37.6843 0.0671504C37.2709 -0.111351 36.7903 0.0782004 36.6108 0.492153C36.4322 0.905255 36.6219 1.38551 37.0361 1.56486L42.1278 3.76552C42.3345 3.85477 42.5692 3.85477 42.7759 3.76552L46.7269 2.05786V5.21733C46.7269 5.66783 47.0927 6.03248 47.5427 6.03248C47.9926 6.03248 48.3584 5.66698 48.3584 5.21733V0.816004C48.3584 0.541453 48.2197 0.285602 47.9901 0.134301H47.9909ZM37.3602 2.20066C36.9094 2.20066 36.5445 2.56616 36.5445 3.01582V5.21648C36.5445 5.66698 36.9102 6.03163 37.3602 6.03163C37.8101 6.03163 38.1759 5.66613 38.1759 5.21648V3.01582C38.1759 2.56531 37.8101 2.20066 37.3602 2.20066Z" fill={theme.palette.figma.white[100]} />
                </g>
                <defs>
                    <clipPath id="clip0_792_18194">
                        <rect width="50" height="6.03248" fill={backgroundColor} />
                    </clipPath>
                </defs>
            </svg>
        </Box>
    );
};
